var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58903 0.215499C4.6349 0.148879 4.69628 0.0944076 4.76787 0.0567765C4.83947 0.0191455 4.91914 -0.000516415 5.00003 -0.000516415C5.08091 -0.000516415 5.16059 0.0191455 5.23218 0.0567765C5.30378 0.0944076 5.36516 0.148879 5.41103 0.215499L9.91103 6.7155C9.96312 6.79047 9.99366 6.87828 9.99935 6.9694C10.005 7.06051 9.98564 7.15144 9.94327 7.2323C9.90091 7.31317 9.83719 7.38088 9.75905 7.42807C9.6809 7.47527 9.59132 7.50014 9.50003 7.5H0.500029C0.408951 7.49962 0.319698 7.47443 0.24187 7.42712C0.164041 7.37981 0.100581 7.31218 0.0583138 7.2315C0.0160467 7.15083 -0.00342795 7.06015 0.00198403 6.96923C0.00739601 6.87832 0.0374899 6.79059 0.0890293 6.7155L4.58903 0.215499Z",
    fill: "#197D21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.3192cbe85129eeee9c1e411f900832c8.svg";
export { ForwardRef as ReactComponent };